import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../../services/apiController';
import { Table, Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExcelDownloadButton from '../../../components/atoms/ExcelDownloadButton';
import Breadcrumb from '../../../components/Breadcrumb';

const DateWiseConsolidatedReport = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [requirementList, setRequirementList] = useState([]);
  const [festivalList, setFestivalList] = useState([]);

  const clickToDownload = useRef(null);

  const [state, setState] = useState({
    companyId: '',
    locationType: '',
    locationId: '',
    festivalId: '',
    festivalDateId: '',
    productId: '',
  });

  function getRequirements(action) {
    try {
      if (state.festivalId) {
        let url = `/fest/requirements/report/festival-datewise-consolidated/?festivalId=${state.festivalId}`;
        if (action === 'download') {
          url += `&action=${action}`;
        }
        get(url).then((response) => {
          if (action === 'download') {
            clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
            setTimeout(() => {
              clickToDownload.current.click();
            }, 500);
          } else {
            setRequirementList(response?.data);
            setTotalRecords(response?.data.data.length);
          }
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    getRequirements();
    getFestivals();
  }, []);

  useEffect(() => {
    if (state.festivalId) {
      getRequirements();
    } else {
      setRequirementList([]);
      setTotalRecords(0);
    }
  }, [state]);

  const getFestivals = () => {
    try {
      get(`/fest/festival`).then((response) => {
        setFestivalList(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Festival' },
          { link: '#', title: 'Report' },
          { link: '#', title: 'Festival Datewise Consolidated' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Report - Festival Datewise Consolidated
          </h4>
          <div className="card-header-actions">
            <Form.Select
              required
              style={{ marginRight: '20px', width: '200px' }}
              name="festivalId"
              value={state.festivalId}
              onChange={(e) => {
                setState({ ...state, festivalId: e.target.value, festivalDateId: '' });
              }}
              aria-label="Floating label select example"
              className="form-select"
            >
              <option value="">Select Festival</option>
              {festivalList.map((item, index) => (
                <option key={index} value={item?.id}>
                  {item?.name} - {item?.year}
                </option>
              ))}
            </Form.Select>
            <ExcelDownloadButton title="Download users" onClick={() => getRequirements('download')} />
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <div className="custom-fest-responsive-table" role="region" aria-labelledby="caption" tabindex="0">
                <Table bordered striped className="text-center">
                  <thead>
                    <tr>
                      {requirementList?.header?.map((headerItem, index) => {
                        return (
                          <th key={index} style={{ whiteSpace: 'nowrap' }}>
                            {headerItem.value}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {requirementList?.data?.map((item, index) => {
                      return (
                        <tr key={index}>
                          {item?.map((i, _index) => {
                            const backgroundColorStyle = i?.color ? { color: i.color, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' };
                            const total = i?.fontWeight && index === totalRecords - 1 ? { fontWeight: i.fontWeight } : {};
                            return (
                              <td key={_index} style={{ ...backgroundColorStyle, ...total }}>
                                {i?.value}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DateWiseConsolidatedReport;
